export const ProjectionSalesTypes = {
  IGetProjectionSalesService: Symbol("IGetProjectionSalesService"),
  ISendProjectionSalesService: Symbol("ISendProjectionSalesService"),
};
